export const INIT_STATE = "INIT_STATE";
export const SET_OPTION = "SET_OPTION";
export const SET_PAGE = "SET_PAGE";
export const SET_ORDER = "SET_ORDER";
export const SET_DIRECTION = "SET_DIRECTION";
export const SET_FILTER = "SET_FILTER";
export const CLEAR_FILTER = "CLEAR_FILTER";

export function initState(stateIdentifier, initialState) {
    return {
        type: INIT_STATE,
        stateIdentifier,
        initialState
    };
}

export function setFilter(stateIdentifier, data) {
    return {
        type: SET_FILTER,
        stateIdentifier,
        data
    };
}

export function setOption(stateIdentifier, data) {
    return {
        type: SET_OPTION,
        stateIdentifier,
        data
    };
}
